import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

const Bullet = styled.div`
  padding-left: 2rem;
  position: relative;
  ${({ mt }) => (mt ? `margin-top: ${mt}` : '')};

  &:before {
    position: absolute;
    ${({ width }) => `width: ${width ? width : '0.75rem'}`};
    ${({ height }) => `height: ${height ? height : '0.75rem'}`};
    left: 0;
    top: 0.5rem;
    content: '';
    border-radius: 50%;
    ${({ backgroundColor }) =>
      `background-color: ${
        backgroundColor ? getColor(backgroundColor) : getColor('gray')
      }`};
  }
`;

export default Bullet;
